import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface userInitialSliceI {
  totalPages: number;
  totalRecords: number;
}

const initialState: userInitialSliceI = {
  totalPages: 0,
  totalRecords: 0
};

export const userSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    setUserTotalPages: (
      state: userInitialSliceI,
      actions: PayloadAction<userInitialSliceI>
    ) => {
      state.totalPages = actions.payload.totalPages;
      state.totalRecords = actions.payload.totalRecords;
    }
  }
});
